import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import moment from 'moment-es6';
import { MomentService } from '../../../shared/moment/moment.service';

import { UtilService, DialogService, NotificationService } from '../../../shared/index';
import { EventsService } from '../../../events/shared/events.service';
import { EventEdit } from '../../../events/shared/event-edit.model';
import { EventRead } from '../../../events/shared/event-read.model';
import { EventPromoCodesService } from '../../../events/shared/promo-codes/event-promo-codes.service';
import { EventPromoCode } from '../../../events/shared/promo-codes/event-promo-code.model';
import { EventItemService } from '../../../events/shared/items/event-item.service';
import { AsyncState } from '../../../shared/model/index';
import { EventItemSummary } from '../../../events/shared/items/event-item-summary.model';
import { UserService } from '../../../users/shared/user.service';
import { UserRead } from '../../../users/shared/user-read.model';
import { TranslationService } from '../../../shared/translation/translation.service';
import { NavigationService } from '../../../shared/navigation/navigation.service';

@Component({
  selector: 'wl-event-settings-promo-codes',
  templateUrl: 'event-settings-promo-codes.component.html',
  providers: [EventsService, EventPromoCodesService, EventItemService, UserService],
    standalone: false
})
export class EventSettingsPromoCodesComponent implements OnInit {
  private _momentService: MomentService;

  public _router: Router;
  public _route: ActivatedRoute;
  public _dialogService: DialogService;
  public _utilService: UtilService;
  public _eventService: EventsService;
  public _eventItemService: EventItemService;
  public _eventPromoCodesService: EventPromoCodesService;
  public _promoCodeIdToDelete: number = 0;
  public _userService: UserService;

  public eventPromoCodes: Array<EventPromoCode>;
  @Input() eventId: number;
  @Input() event: EventEdit;
  public loadingEventPromoCodesMethods: boolean;
  public selectedEventPromoCode: EventPromoCode;
  public eventItems: Array<any>;
  public loadingPromoCodes: boolean = false;
  public loadingEventItems: boolean = false;
  public loadPromoCodesError: string = '';
  public loadPromoCodeState: AsyncState = new AsyncState();
  public saving: boolean = false;
  public saveError: string = '';
  public deleting: boolean = false;
  public deleteError: string = '';
  public userAccessLevel: number;

  public showEditModal = false;
  public showDeleteModal = false;

  public constructor(
    router: Router,
    route: ActivatedRoute,
    dialogService: DialogService,
    utilService: UtilService,
    eventPromoCodesService: EventPromoCodesService,
    eventService: EventsService,
    eventItemService: EventItemService,
    userService: UserService,
    momentService: MomentService,
    public _notificationService: NotificationService,
    public _translationService: TranslationService,
    public _navigationService: NavigationService
  ) {
    this._router = router;
    this._route = route;
    this._dialogService = dialogService;
    this._utilService = utilService;
    this._eventPromoCodesService = eventPromoCodesService;
    this._eventService = eventService;
    this._eventItemService = eventItemService;
    this._userService = userService;
    this._momentService = momentService;

    this.eventPromoCodes = new Array<EventPromoCode>();
    this.eventId = 0;
    this.loadingEventPromoCodesMethods = false;
    this.selectedEventPromoCode = new EventPromoCode();
    this.eventItems = new Array<any>();
    this.userAccessLevel = 0;
  }

  public newEventPromoCodes = (): void => {
    this.saving = false;
    this.saveError = '';

    this.loadPromoCodeState.busy = false;
    this.loadPromoCodeState.message = '';
    this.loadPromoCodeState.success = true;

    var newPromoCode = new EventPromoCode();
    newPromoCode.EventId = this.eventId;

    if (this.event && this.event.StartDate)
      newPromoCode.EndDate = this._momentService
        .getMomentByDate(this.event.StartDate)
        .startOf('day')
        .toDate();

    this.selectedEventPromoCode = newPromoCode;
    this.showEditModal = true;

    this._eventItemService.getEventItems(this.eventId).then(data => {
      this.eventItems = data.map(item => {
        return {
          eventItemName: item.Descr,
          apply: true,
          eventItemId: item.EventItemId,
        };
      });
    });
  };

  public savePromoCode = (): void => {
    this.saving = true;
    this.saveError = '';

    this.selectedEventPromoCode.EventItemIds = this.eventItems.filter(x => x.apply).map(x => x.eventItemId);

    // force expiration (flag not in ui)
    this.selectedEventPromoCode.Expires = true;

    this._eventPromoCodesService
      .upsertEventPromoCode(this.selectedEventPromoCode)
      .then(() => {
        this.saving = false;
        this.showEditModal = false;
        this.refreshPromoCodesList();
        this._translationService
          .getTitlecase('events.settings.promo-codes.save-success-message')
          .then(translation => this._notificationService.success(translation));
      })
      .catch(error => {
        this.saving = false;
        this.saveError = this._utilService.extractErrorMessage(error);
      });
  };

  public editPromoCode = (promoCodeId: number): void => {
    this.saving = false;
    this.saveError = '';

    this.loadPromoCodeState.busy = true;
    this.loadPromoCodeState.message = '';
    this.loadPromoCodeState.success = false;

    this.loadingEventPromoCodesMethods = true;

    let promises: Promise<any>[] = [];

    promises.push(this._eventPromoCodesService.getEventPromoCode(promoCodeId));

    promises.push(this._eventItemService.getEventItems(this.eventId));

    // await both promises
    Promise.all(promises)
      .then(answers => {
        this.loadPromoCodeState.busy = false;
        this.loadPromoCodeState.success = true;

        if (answers.length > 0) this.selectedEventPromoCode = answers[0];

        if (!this.selectedEventPromoCode.EventItemIds) this.selectedEventPromoCode.EventItemIds = [];

        if (answers.length > 1) {
          var eventItems = <Array<EventItemSummary>>answers[1];
          this.eventItems = eventItems.map(item => {
            return {
              eventItemName: item.Descr,
              apply: this.selectedEventPromoCode.EventItemIds.some(x => x == item.EventItemId),
              eventItemId: item.EventItemId,
            };
          });
        }

        this.showEditModal = true;
      })
      .catch(error => {
        this.loadPromoCodeState.busy = false;
        this.loadPromoCodeState.message = this._utilService.extractErrorMessage(error);
        this.loadPromoCodeState.success = false;
      });
  };

  public confirmDeletePromoCode(promoCodeId: number): void {
    this.deleteError = '';
    this._promoCodeIdToDelete = promoCodeId;
    this.showDeleteModal = true;
  }

  public deletePromoCode(): void {
    this.deleting = true;
    this.deleteError = '';

    this._eventPromoCodesService
      .deleteEventPromoCode(this._promoCodeIdToDelete)
      .then(() => {
        this.deleting = false;
        this.showDeleteModal = false;
        this.refreshPromoCodesList();
      })
      .catch(error => {
        this.deleting = false;
        this.deleteError = this._utilService.extractErrorMessage(error);
      });
  }

  public exportPromoCode = (promoCodeId: number): void => {
    this._eventPromoCodesService.exportPromoCode(this.eventId, promoCodeId).then((data: string) => {
      this._navigationService.popupSafeNavigate(data);
    });
  };

  public exportAllPromoCodes = (): void => {
    this._eventPromoCodesService.exportPromoCodes(this.eventId).then((data: string) => {
      this._navigationService.popupSafeNavigate(data);
    });
  };

  public refreshPromoCodesList(): void {
    this.loadingPromoCodes = true;
    this.loadPromoCodesError = '';

    this._eventPromoCodesService
      .getEventPromoCodes(this.eventId)
      .then((data: Array<EventPromoCode>) => {
        this.eventPromoCodes = data;

        if (this.eventPromoCodes.length > 0) {
          this.selectedEventPromoCode = this.eventPromoCodes[0];
        }

        this.loadingPromoCodes = false;
      })
      .catch(error => {
        this.loadingPromoCodes = false;
        this.loadPromoCodesError = this._utilService.extractErrorMessage(error);
      });
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      if (this._utilService.isNumeric(params['id'])) {
        let id = Number(params['id']);
        this.eventId = id;
        this.refreshPromoCodesList();
      }
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;
    });
  }
}
